import { Injectable, ViewChild } from '@angular/core';

import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { ConfigService } from './config.service';

import { BraintreeOptions } from './models';

// import { braintree } from 'braintree-web';

declare var braintree: any;

@Injectable()
export class BraintreePaymentService {

  // braintree: any = require('braintree-web');

  constructor(private config: ConfigService,
    private http: Http) {
  }

  setup(options: BraintreeOptions, success: any) {
    this.getToken()
      .subscribe(
        token => {
          braintree.setup(token, 'dropin', {
            container: options.container,
            paypal: {
                singleUse: true,
                amount: options.price,
                currency: 'EUR',
                button: {
                    type: 'checkout'
                }
            },
            onReady: options.onReady,
            onError: options.onError,
            onPaymentMethodReceived: success
          });
        },
        error => options.onError(error)
      );
  }

  private getToken(): Observable<string> {
    return this.http.get(this.config.braintreeTokenUrl)
      .map(res => this.mapResponse(res))
      .catch(err => this.handleError(err));
  }

  private mapResponse(res: Response) {
    if (!res.ok) {
      this.handleError(res);
    } else {
      return res.text();
    }
  }

  private handleError(error: any) {
    let errMsg;

    if (!!error._body) {
      let errJson = JSON.parse(error._body);
      errMsg = (errJson.ExceptionMessage) ? errJson.ExceptionMessage : error._body;
    } else {
      errMsg = (error.message) ? error.message :
        error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    }

    console.error(errMsg); // log to console instead
    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/commons/braintree-payment.service.ts